<template>
  <div class="w-full h-full">
    <div class="flex mb-20px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="风险点名称"
        v-model="equipSearchData.keywords"
        clearable
      ></el-input>
      <el-button
        class="round-button"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleSearch('equip')"
      ></el-button>
    </div>
    <el-table
      :data="equipDataList"
      class="w-full"
      :height="tableHeight"
      v-loading="equipTableLoading"
      :span-method="spanMethod"
      :row-class-name="rowClassName"
      @cell-mouse-enter="handleMouseEnter"
      @cell-mouse-leave="handleMouseLeave"
    >
      <el-table-column label="序号" prop="specialId" width="50"></el-table-column>
      <el-table-column
        label="风险点名称"
        width="180"
        prop="riskPointName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="作业步骤"
        prop="jobStep"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="危险源或潜在事件"
        prop="hiddenEvent"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="危险有害因素分类"
        prop="harmElementType"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="可能导致的事故类型"
        width="180"
        prop="accidentType"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="equipTableSizeChange"
      @current-change="equipTableCurrentChange"
      :current-page.sync="equipPageConfig.SkipCount"
      :page-size.sync="equipPageConfig.MaxResultCount"
      layout="prev, pager, next"
      :total="equipTotalCount"
      class="flex justify-center mt-20px ml-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { HiddenRisksSmartScreenApi } from '@wiz-api/double-prevention-management'

const hiddenRisksSmartScreenApi = new HiddenRisksSmartScreenApi()
export default {
  name: 'equip-list',
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      cellIndex: -1,
      rowIndex: 1,
      position: 0,
      spanArrObj: {},
      selectionEquipData: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        areaId: this.areaId,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 160px)'
    },
  },
  watch: {},
  created() {
    this.getEquipList()
  },
  methods: {
    // 获取合并行参数(数组)
    rowspan(data) {
      const list = []
      this.rowIndex = 1
      this.position = 0
      this.spanArrObj = {}
      _.forEach(data, (item, index) => {
        if (item.jobIdentifyDtos && item.jobIdentifyDtos.length > 0) {
          _.forEach(item.jobIdentifyDtos, (ele) => {
            ele.cellIndex = index + 1
            list.push({ ...item, ...ele })
          })
        } else {
          list.push({ ...item })
        }
      })
      list.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj.riskActivityRelationalId) {
            this.spanArrObj.riskActivityRelationalId = []
          }
          this.spanArrObj.riskActivityRelationalId.push(1)
          this.position = 0
          item.specialId = this.rowIndex
          this.rowIndex++
        } else if (
          list[index].riskActivityRelationalId === list[index - 1].riskActivityRelationalId
        ) {
          this.spanArrObj.riskActivityRelationalId[this.position] += 1
          this.spanArrObj.riskActivityRelationalId.push(0)
        } else {
          if (!this.spanArrObj.riskActivityRelationalId) {
            this.spanArrObj.riskActivityRelationalId = []
          }
          item.specialId = this.rowIndex
          this.rowIndex++
          this.spanArrObj.riskActivityRelationalId.push(1)
          this.position = index
        }
      })
      this.equipDataList = list
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1].includes(columnIndex)) {
        const _row = this.spanArrObj.riskActivityRelationalId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    // 鼠标进入单元格
    handleMouseEnter(row, column, cell, event) {
      _.forEach(this.equipDataList, (item, index) => {
        if (row.cellIndex === item.cellIndex) {
          this.cellIndex = row.cellIndex
        }
      })
    },
    // rowIndex添加类名
    rowClassName({ row, rowIndex }) {
      let r = -1
      _.forEach(this.equipDataList, (item) => {
        if (this.cellIndex === row.cellIndex) {
          r = rowIndex
        }
      })
      if (rowIndex === r) {
        return 'hover-row'
      }
    },
    // 鼠标离开单元格
    handleMouseLeave(row, column, cell, event) {
      this.cellIndex = -1
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [
        err,
        res,
      ] = await hiddenRisksSmartScreenApi.identificationJobDangerousHarmfulFactorPagedListQuery(
        data
      )
      if (!err) {
        this.rowspan(res.items)
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/loading.scss';
::v-deep .el-button {
  background-image: var(--cockpitButtonBg) !important;
}
::v-deep .el-input__inner {
  border: none;
}
</style>
